import { useEffect, useState } from 'react';
import { navBoards } from '@/mocks/home';

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [tipOpen, setTipOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkBase = scrolled
    ? 'text-foreground-700 hover:text-primary-700 hover:bg-primary-50'
    : 'text-background-100 hover:text-background-50 hover:bg-background-50/15';

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="h-[72px] w-full flex items-center justify-between gap-4 px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
          <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-water-flash-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading font-bold text-lg tracking-wide whitespace-nowrap ${
                scrolled ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              吃瓜黑料网
            </span>
            <span
              className={`text-[11px] mt-1 tracking-[0.18em] whitespace-nowrap ${
                scrolled ? 'text-foreground-500' : 'text-background-200'
              }`}
            >
              资源汇总 · 板块索引
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navBoards.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${linkBase}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3 shrink-0">
          <div
            className={`flex items-center gap-2 h-10 px-3 rounded-md border transition-colors ${
              scrolled
                ? 'border-background-300 bg-background-100 text-foreground-500'
                : 'border-background-50/30 bg-background-50/10 text-background-200'
            }`}
          >
            <i className="ri-search-line text-sm"></i>
            <input
              type="text"
              placeholder="搜索板块 / 关键词"
              className={`w-40 lg:w-52 bg-transparent outline-none text-sm placeholder:text-current ${
                scrolled ? 'text-foreground-900 placeholder:text-foreground-400' : 'text-background-50 placeholder:text-background-300'
              }`}
            />
          </div>
          <div className="relative">
            <button
              type="button"
              onClick={() => setTipOpen((v) => !v)}
              className="h-10 px-4 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              提交爆料
            </button>
            {tipOpen ? (
              <div className="absolute right-0 top-12 w-64 p-4 rounded-lg border border-background-200 bg-background-50 text-left">
                <p className="text-sm text-foreground-800 leading-relaxed">
                  投稿入口正在整理中，先按板块索引浏览即可。当前站点为演示展示，未接入提交接口。
                </p>
                <button
                  type="button"
                  onClick={() => setTipOpen(false)}
                  className="mt-3 text-xs text-primary-700 hover:text-primary-800 cursor-pointer"
                >
                  知道了
                </button>
              </div>
            ) : null}
          </div>
        </div>

        <button
          type="button"
          aria-label="菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled ? 'text-foreground-900 bg-background-100' : 'text-background-50 bg-background-50/15'
          }`}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </div>

      {menuOpen ? (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <div className="flex flex-wrap gap-2 mb-4">
            {navBoards.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2 rounded-md text-sm bg-background-100 text-foreground-700 cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </div>
          <div className="flex items-center gap-2 h-11 px-3 rounded-md border border-background-300 bg-background-100 text-foreground-500">
            <i className="ri-search-line text-sm"></i>
            <input
              type="text"
              placeholder="搜索板块 / 关键词"
              className="w-full bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-400"
            />
          </div>
          <button
            type="button"
            onClick={() => {
              setMenuOpen(false);
              setTipOpen(true);
            }}
            className="mt-3 w-full h-11 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap"
          >
            提交爆料
          </button>
        </div>
      ) : null}
    </header>
  );
}